import { getStore, FolderTreeData } from 'owa-folders';
import { getDefaultLogonEmailAddress } from 'owa-session-store';

/**
 * Selector for getting all shared folders mailbox data
 */
export function getAllSharedFoldersData(userIdentity?: string): FolderTreeData[] {
    if (!userIdentity) {
        userIdentity = getDefaultLogonEmailAddress();
    }
    const mailboxStore = getStore().mailboxFolderTreeData.get(userIdentity);
    const allSharedFolderEmails = mailboxStore.sharedFolderUserEmails;
    return allSharedFolderEmails.map(sharedFolderEmail =>
        mailboxStore.folderTreeTable.get(sharedFolderEmail)
    );
}
